import { useWeddingRsvp } from '@bridebook/web/lib/rsvp/query/hooks/wedding/use-wedding-rsvp';
import { useCreateWeddingRsvp } from '@bridebook/web/lib/rsvp/query/hooks/wedding/use-create-wedding-rsvp';
import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';

export const useCreateWeddingRsvpIfMissing = () => {
  const { data: weddingRsvp, isLoading: isWeddingRsvpQueryLoading } = useWeddingRsvp();
  const { mutateAsync: createWeddingRsvpAsync } = useCreateWeddingRsvp();

  // add wedding rsvp entry to db when user enters the view for the first time
  useEffect(() => {
    if (!isWeddingRsvpQueryLoading && (!weddingRsvp || isEmpty(weddingRsvp))) {
      createWeddingRsvpAsync({ questions: [] });
    }
  }, [isWeddingRsvpQueryLoading, weddingRsvp, createWeddingRsvpAsync]);
};
